export const DEFAULT_LANGUAGES_VALUES: string[] = [
  "cs",
  "de",
  "en",
  "es",
  "fr",
  "hr",
  "it",
  "nl",
  "pl",
  "ro",
  "sl",
  "sk",
];
